import React, { useState, useEffect } from 'react';
import Step3 from './Step3';
import Step4 from './Step4';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import './payment.css';
import { Snackbar, Alert } from '@mui/material';
import env from "../../env.json";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

const SettlementReportPage = () => {
  const { BASE_URL } = env;
  const { role = '', accessList = [] } = JSON.parse(localStorage.getItem('admin')) || {};
  const isReportViewer = role === 'earnings-report-only';
  const [reportData, setReportData] = useState(null);
  const [selectedEntries, setSelectedEntries] = useState([]);
  const [currentStep, setCurrentStep] = useState(3);



  // For the available dates:


  const [availableDates, setAvailableDates] = useState([]);



  // For retaining the data in the when coming back to the step 3 from step 4

  // In parent component

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [reportType, setReportType] = useState('all');

  const [reportGenerated, setReportGenerated] = useState(false);




  const [committedReports, setCommittedReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [message, setMessage] = useState(null);
  const [reportDataTT, setReportDataTT] = useState(null);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success' // 'success', 'error', 'warning', 'info'
  });

  // Email UI state (for sending selected committed report)
  const [emailInput, setEmailInput] = useState('');
  const [emailSubject, setEmailSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [includeReceipt, setIncludeReceipt] = useState(true);
  const [includeSettlement, setIncludeSettlement] = useState(true);
  const [isSending, setIsSending] = useState(false);

  

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  };

  // Helper function to hide snackbar
  const hideSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar(prev => ({ ...prev, open: false }));
  };



  useEffect(() => {
    // fetch("http://localhost:8080/committedReports")
    fetch(`${BASE_URL}/committedReports`)
    // fetch("https://admin-api.cruze.asia/committedReports")
      .then(res => res.json())
      .then(data => {
        setCommittedReports(data)
        console.log("Loaded committed report", data);

        // toast.success("Committed report loaded successfully!", {
        //   position: "top-right",
        //   autoClose: 3000,
        // });
        // here you can pass this data into your Step4-like UI or download function
      })
      // .then(data => setCommittedReports(data))
      .catch(err => {
        console.error(err);
        // setMessage("❌ Failed to load committed report contact Cruze - WMD Admin")
        // toast.error("Failed to load committed report", {
        //   position: "top-right",
        //   autoClose: 3000,
        // });
      });
    // .catch(err => console.error("Error fetching committed reports", err));
  }, []);




  // useEffect(() => {
  //   if (!selectedReport) return;

  //   fetch(`http://localhost:8080/committedReportsById/${selectedReport}`)
  //     .then(res => res.json())
  //     .then(data => {
  //       console.log("Loaded committed report", data);
  //       setReportDataTT(data);
  //       setMessage("✅ Committed report loaded successfully!");

  //       // 👇 Auto-generate Excel immediately after loading
  //       // generatePayoutFileForReport("Ujjivan Bank", data);
  //     })
  //     .catch(err => {
  //       console.error(err);
  //       setMessage("❌ Failed to load committed report contact Cruze - WMD Admin")
  //     });
  // }, [selectedReport]);


  
  useEffect(() => {
    if (currentStep === 3) {
      fetch(`${BASE_URL}/committedReports`).then(r=>r.json()).then(setCommittedReports).catch(()=>{});
      fetch(`${BASE_URL}/getAvailableTransactionDates`)
        .then(r=>r.json())
        .then(data => {
          const formatted = (data.availableDates||[]).map(item=>({ ...item, formattedDate: formatDate(item.date) }));
          setAvailableDates(formatted);
        })
        .catch(()=>{});
    }
  }, [currentStep]);
// With SnackBAr

  useEffect(() => {
    if (!selectedReport) return;
  
    fetch(`${BASE_URL}/committedReportsById/${selectedReport}`)
    // fetch(`http://localhost:8080/committedReportsById/${selectedReport}`)
    // fetch(`https://admin-api.cruze.asia/committedReportsById/${selectedReport}`)
      .then(res => res.json())
      .then(data => {
        console.log("Loaded committed report", data);
        setReportDataTT(data);
        
        // ✅ Show success snackbar
        showSnackbar("Committed report loaded successfully!", "success");
  
        // Auto-generate Excel immediately after loading
        // generatePayoutFileForReport("Ujjivan Bank", data);
      })
      .catch(err => {
        console.error(err);
        
        // ✅ Show error snackbar
        showSnackbar("Failed to load committed report. Contact Cruze-WMD Admin", "error");
      });
  }, [selectedReport]);

  // Ticket-admin helpers: PDF generators using committed report
  const getEntryTheatreName = (entry) => {
    return (
      entry.theatreName ||
      entry.theaterName ||
      entry.theaterServiceRef?.theatreName ||
      entry.theaterServiceRef?.theaterName ||
      entry.rawData?.payment?.theatreName ||
      entry.rawData?.payment?.theaterName ||
      entry.theaterBankDetails?.accountHolderName ||
      entry.theaterBankDetails?.beneficiaryName ||
      ''
    );
  };

  const normalizeName = (s = '') =>
    String(s)
      .toLowerCase()
      .replace(/[^\p{L}\p{N}]+/gu, ' ') // keep letters/numbers, strip punctuation
      .replace(/\s+/g, ' ')
      .trim();

  const generateCommittedTheaterPDF = () => {
    if (!reportDataTT?.summary?.detailedEntries) {
      alert('No report loaded');
      return;
    }
    let entries = reportDataTT.summary.detailedEntries
      .filter(e => e.serviceType === 'theater');
    if (isReportViewer && Array.isArray(accessList) && accessList.length > 0) {
      const allowed = accessList.map(normalizeName);
      entries = entries.filter(e => {
        const name = normalizeName(getEntryTheatreName(e));
        return allowed.some(a => name.includes(a) || a.includes(name));
      });
      if (entries.length === 0) {
        showSnackbar('No ticket entries matched your access theatre(s).', 'warning');
      }
    }
    // Use landscape to avoid column overlap and improve readability
    const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    doc.setFontSize(16);
    doc.text('Settlement Report (Tickets)', 14, 20);
    doc.setFontSize(11);
    doc.text(`Period: ${formatDateUTC(reportDataTT.periodStart)} to ${formatDateUTC(reportDataTT.periodEnd)}`, 14, 28);
    const headers = [[
      'Invoice', 'Movie', 'Show Date', 'Transaction', 'Amount', 'Payable', 'Base', 'Taxes', 'Gateway', 'Fee', 'Platform Tax', 'Status'
    ]];
    const data = entries.map(entry => [
      entry.invoiceNumber || 'N/A',
      entry.movieName || 'N/A',
      (entry.showDate ? new Date(entry.showDate).toLocaleDateString('en-IN') : 'N/A'),
      entry.transactionId || 'N/A',
      `Rs. ${(entry.customerAmount||0).toFixed(2)}`,
      `Rs. ${(entry.payableToPartner||0).toFixed(2)}`,
      `Rs. ${(entry.baseAmount||0).toFixed(2)}`,
      `Rs. ${(entry.taxes||0).toFixed(2)}`,
      `Rs. ${(entry.gatewayCharges||0).toFixed(2)}`,
      `Rs. ${(entry.platformEarnings||0).toFixed(2)}`,
      `Rs. ${(entry.platformTax||0).toFixed(2)}`,
      entry.status || 'N/A'
    ]);
    autoTable(doc, {
      head: headers,
      body: data,
      startY: 34,
      theme: 'grid',
      styles: { fontSize: 7, overflow: 'lineBreak', cellPadding: 1.5, lineWidth: 0.1, lineColor: [200,200,200] },
      tableLineColor: [160,160,160],
      tableLineWidth: 0.2,
      margin: { left: 14, right: 20 },
      // Set explicit widths to prevent overlap in PDF
      columnStyles: {
        0: { cellWidth: 20 },  // Invoice
        1: { cellWidth: 34 },  // Movie
        2: { cellWidth: 22 },  // Show Date
        3: { cellWidth: 44 },  // Transaction
        4: { cellWidth: 18 },  // Amount
        5: { cellWidth: 18 },  // Payable
        6: { cellWidth: 16 },  // Base
        7: { cellWidth: 16 },  // Taxes
        8: { cellWidth: 18 },  // Gateway
        9: { cellWidth: 16 },  // Fee
        10: { cellWidth: 20 }, // Platform Tax
        11: { cellWidth: 16 }, // Status
      },
      headStyles: { fillColor: [22,160,133], textColor: [255,255,255] },
      alternateRowStyles: { fillColor: [245,245,245] },
      didParseCell: (d) => {
        if ([0,1,2,3,11].includes(d.column.index)) d.cell.styles.halign = 'left';
        else d.cell.styles.halign = 'right';
      }
    });
    doc.save(`Tickets_Settlement_${new Date().toISOString().slice(0,10)}.pdf`);
  };

  const generateTicketsReceiptPDF = () => {
    if (!reportDataTT?.summary?.detailedEntries) {
      alert('No report loaded');
      return;
    }
    let entries = reportDataTT.summary.detailedEntries.filter(e => e.serviceType === 'theater');
    if (isReportViewer && Array.isArray(accessList) && accessList.length > 0) {
      const allowed = accessList.map(normalizeName);
      entries = entries.filter(e => {
        const name = normalizeName(getEntryTheatreName(e));
        return allowed.some(a => name.includes(a) || a.includes(name));
      });
      if (entries.length === 0) {
        showSnackbar('No ticket entries matched your access theatre(s).', 'warning');
      }
    }
    const isCash = (e) => (e.transactionId || '').includes('CASH') && e.status === 'NA';
    const totalCollected = entries.reduce((s,e) => s + (e.customerAmount||0), 0);
    const cash = entries.filter(isCash).reduce((acc,e)=>({
      amount: acc.amount + (e.customerAmount||0),
      platformFee: acc.platformFee + (e.platformEarnings||0),
      platformTax: acc.platformTax + (e.platformTax||0)
    }), {amount:0, platformFee:0, platformTax:0});
    const digital = entries.filter(e => !isCash(e)).reduce((acc,e)=>({
      amount: acc.amount + (e.customerAmount||0),
      gatewayCharges: acc.gatewayCharges + (e.gatewayCharges||0),
      platformFee: acc.platformFee + (e.platformEarnings||0),
      platformTax: acc.platformTax + (e.platformTax||0)
    }), {amount:0, gatewayCharges:0, platformFee:0, platformTax:0});
    const afterCash = totalCollected - cash.amount;
    const afterDigital = afterCash - digital.gatewayCharges - digital.platformFee - digital.platformTax;
    const afterAll = afterDigital - (cash.platformFee + cash.platformTax);
    const tcs = afterAll * 0.01;
    const finalPayable = afterAll - tcs;

    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text('JSW Payment Receipt (Tickets)', 14, 20);
    doc.setFontSize(11);
    doc.text(`Period: ${formatDateUTC(reportDataTT.periodStart)} to ${formatDateUTC(reportDataTT.periodEnd)}`, 14, 28);
    let y = 38;
    const line = (label, value) => { doc.text(label, 14, y); doc.text(`Rs. ${value.toFixed(2)}`, 180, y, { align:'right' }); y += 6; };
    line('Total Collected', totalCollected);
    line('Less: Cash Transactions (amount)', cash.amount);
    line('Less: Digital Gateway Charges', digital.gatewayCharges);
    line('Less: Digital Platform Fee', digital.platformFee);
    line('Less: Digital Platform Tax', digital.platformTax);
    line('Less: Cash Platform Fees + Tax', cash.platformFee + cash.platformTax);
    y += 2; doc.line(14, y, 196, y); y += 6;
    line('Subtotal (after deductions)', afterAll);
    line('TCS @ 1%', tcs);
    y += 2; doc.line(14, y, 196, y); y += 6;
    doc.setFont(undefined, 'bold');
    line('Final Amount Payable to JSW', finalPayable);
    doc.setFont(undefined, 'normal');
    doc.save(`JSW_Payment_Receipt_Tickets_${new Date().toISOString().slice(0,10)}.pdf`);
  };

  // Email helpers: build PDFs in-memory and send via backend
  const buildCommittedTheaterPdfDataUri = () => {
    if (!reportDataTT?.summary?.detailedEntries) return null;
    let entries = reportDataTT.summary.detailedEntries.filter(e => e.serviceType === 'theater');
    if (isReportViewer && Array.isArray(accessList) && accessList.length > 0) {
      const allowed = accessList.map(normalizeName);
      entries = entries.filter(e => {
        const name = normalizeName(getEntryTheatreName(e));
        return allowed.some(a => name.includes(a) || a.includes(name));
      });
    }
    // Match on-screen PDF: landscape + table with Movie and Show Date
    const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    doc.setFontSize(16);
    doc.text('Settlement Report (Tickets)', 14, 20);
    doc.setFontSize(11);
    doc.text(`Period: ${formatDateUTC(reportDataTT.periodStart)} to ${formatDateUTC(reportDataTT.periodEnd)}`, 14, 28);
    const headers = [[
      'Invoice', 'Movie', 'Show Date', 'Transaction', 'Amount', 'Payable', 'Base', 'Taxes', 'Gateway', 'Fee', 'Platform Tax', 'Status'
    ]];
    const data = entries.map(entry => [
      entry.invoiceNumber || 'N/A',
      entry.movieName || 'N/A',
      (entry.showDate ? new Date(entry.showDate).toLocaleDateString('en-IN') : 'N/A'),
      entry.transactionId || 'N/A',
      `Rs. ${(entry.customerAmount||0).toFixed(2)}`,
      `Rs. ${(entry.payableToPartner||0).toFixed(2)}`,
      `Rs. ${(entry.baseAmount||0).toFixed(2)}`,
      `Rs. ${(entry.taxes||0).toFixed(2)}`,
      `Rs. ${(entry.gatewayCharges||0).toFixed(2)}`,
      `Rs. ${(entry.platformEarnings||0).toFixed(2)}`,
      `Rs. ${(entry.platformTax||0).toFixed(2)}`,
      entry.status || 'N/A'
    ]);
    autoTable(doc, {
      head: headers,
      body: data,
      startY: 34,
      theme: 'grid',
      styles: { fontSize: 7, overflow: 'lineBreak', cellPadding: 1.5, lineWidth: 0.1, lineColor: [200,200,200] },
      tableLineColor: [160,160,160],
      tableLineWidth: 0.2,
      margin: { left: 14, right: 20 },
      columnStyles: {
        0: { cellWidth: 20 },  // Invoice
        1: { cellWidth: 34 },  // Movie
        2: { cellWidth: 22 },  // Show Date
        3: { cellWidth: 44 },  // Transaction
        4: { cellWidth: 18 },  // Amount
        5: { cellWidth: 18 },  // Payable
        6: { cellWidth: 16 },  // Base
        7: { cellWidth: 16 },  // Taxes
        8: { cellWidth: 18 },  // Gateway
        9: { cellWidth: 16 },  // Fee
        10: { cellWidth: 20 }, // Platform Tax
        11: { cellWidth: 16 }, // Status
      },
      headStyles: { fillColor: [22,160,133], textColor: [255,255,255] },
      alternateRowStyles: { fillColor: [245,245,245] },
      didParseCell: (d) => {
        if ([0,1,2,3,11].includes(d.column.index)) d.cell.styles.halign = 'left';
        else d.cell.styles.halign = 'right';
      }
    });
    return doc.output('datauristring');
  };

  const buildTicketsReceiptPdfDataUri = () => {
    if (!reportDataTT?.summary?.detailedEntries) return null;
    let entries = reportDataTT.summary.detailedEntries.filter(e => e.serviceType === 'theater');
    if (isReportViewer && Array.isArray(accessList) && accessList.length > 0) {
      const allowed = accessList.map(normalizeName);
      entries = entries.filter(e => {
        const name = normalizeName(getEntryTheatreName(e));
        return allowed.some(a => name.includes(a) || a.includes(name));
      });
    }
    const isCash = (e) => (e.transactionId || '').includes('CASH') && e.status === 'NA';
    const totalCollected = entries.reduce((s,e) => s + (e.customerAmount||0), 0);
    const cash = entries.filter(isCash).reduce((acc,e)=>({
      amount: acc.amount + (e.customerAmount||0),
      platformFee: acc.platformFee + (e.platformEarnings||0),
      platformTax: acc.platformTax + (e.platformTax||0)
    }), {amount:0, platformFee:0, platformTax:0});
    const digital = entries.filter(e => !isCash(e)).reduce((acc,e)=>({
      amount: acc.amount + (e.customerAmount||0),
      gatewayCharges: acc.gatewayCharges + (e.gatewayCharges||0),
      platformFee: acc.platformFee + (e.platformEarnings||0),
      platformTax: acc.platformTax + (e.platformTax||0)
    }), {amount:0, gatewayCharges:0, platformFee:0, platformTax:0});
    const afterCash = totalCollected - cash.amount;
    const afterDigital = afterCash - digital.gatewayCharges - digital.platformFee - digital.platformTax;
    const afterAll = afterDigital - (cash.platformFee + cash.platformTax);
    const tcs = afterAll * 0.01;
    const finalPayable = afterAll - tcs;
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text('JSW Payment Receipt (Tickets)', 14, 20);
    doc.setFontSize(11);
    doc.text(`Period: ${formatDateUTC(reportDataTT.periodStart)} to ${formatDateUTC(reportDataTT.periodEnd)}`, 14, 28);
    let y = 38;
    const line = (label, value) => { doc.text(label, 14, y); doc.text(`Rs. ${value.toFixed(2)}`, 180, y, { align:'right' }); y += 6; };
    line('Total Collected', totalCollected);
    line('Less: Cash Transactions (amount)', cash.amount);
    line('Less: Digital Gateway Charges', digital.gatewayCharges);
    line('Less: Digital Platform Fee', digital.platformFee);
    line('Less: Digital Platform Tax', digital.platformTax);
    line('Less: Cash Platform Fees + Tax', cash.platformFee + cash.platformTax);
    y += 2; doc.line(14, y, 196, y); y += 6;
    line('Subtotal (after deductions)', afterAll);
    line('TCS @ 1%', tcs);
    y += 2; doc.line(14, y, 196, y); y += 6;
    doc.setFont(undefined, 'bold');
    line('Final Amount Payable to JSW', finalPayable);
    doc.setFont(undefined, 'normal');
    return doc.output('datauristring');
  };

  const parseEmails = (input) => input.split(/[;,\s]+/).map(s => s.trim()).filter(Boolean);
  const isValidEmail = (email) => /[^\s@]+@[^\s@]+\.[^\s@]+/.test(email);

  const handleSendEmail = async () => {
    if (!selectedReport) {
      alert('Please select a committed report first.');
      return;
    }
    const recipients = parseEmails(emailInput);
    if (recipients.length === 0 || !recipients.every(isValidEmail)) {
      alert('Enter at least one valid recipient email (comma or space separated).');
      return;
    }
    if (!includeReceipt && !includeSettlement) {
      alert('Select at least one attachment type.');
      return;
    }

    setIsSending(true);
    try {
      const attachments = [];
      const start = formatDateUTC(reportDataTT?.periodStart || '');
      const end = formatDateUTC(reportDataTT?.periodEnd || '');
      if (includeSettlement) {
        const dataUri = buildCommittedTheaterPdfDataUri();
        if (!dataUri) throw new Error('Failed to build Settlement PDF');
        attachments.push({
          filename: `Tickets_Settlement_${start}_to_${end}.pdf`,
          contentBase64: dataUri.split(',')[1],
          contentType: 'application/pdf'
        });
      }
      if (includeReceipt) {
        const dataUri = buildTicketsReceiptPdfDataUri();
        if (!dataUri) throw new Error('Failed to build Payment Receipt PDF');
        attachments.push({
          filename: `JSW_Payment_Receipt_Tickets_${start}_to_${end}.pdf`,
          contentBase64: dataUri.split(',')[1],
          contentType: 'application/pdf'
        });
      }

      const subject = emailSubject?.trim() || `JSW Reports ${start} to ${end}`;
      const body = emailBody?.trim() || '';
      const res = await fetch(`${BASE_URL}/email/send-reports`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ recipients, subject, message: body, attachments, meta: { reportId: selectedReport } })
      });

      console.log('the result of the email is', res);
      if (!res.ok) throw new Error('Email send failed');
      showSnackbar('Email sent successfully', 'success');
    } catch (e) {
      console.error(e);
      showSnackbar('Failed to send email', 'error');
    } finally {
      setIsSending(false);
    }
  };

  
  





  // Date formatting function
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  };



  useEffect(() => {
    const fetchAvailableDates = async () => {
      try {
        const res = await fetch(`${BASE_URL}/getAvailableTransactionDates`);
        // const res = await fetch('http://localhost:8080/getAvailableTransactionDates');
        //  const res = await fetch('https://admin-api.cruze.asia/getAvailableTransactionDates');
        const data = await res.json();

        // Format dates to dd/mm/yyyy before storing in state
        const formattedDates = (data.availableDates || []).map(item => ({
          ...item,
          formattedDate: formatDate(item.date) // Add formatted date
        }));

        console.log('formatted Dates', formattedDates);

        setAvailableDates(formattedDates);
      } catch (err) {
        console.error('Error fetching available transaction dates', err);
      }
    };

    fetchAvailableDates();
  }, []);



  // useEffect(() => {
  //   const fetchAvailableDates = async () => {
  //     try {
  //       const res = await fetch('http://localhost:8080/getAvailableTransactionDates'); // Update path if needed
  //       // const res = await fetch('https://admin-api.cruze.asia/getAvailableTransactionDates'); // Update path if needed
  //       const data = await res.json();

  //       console.log('data',data);
  //       setAvailableDates(data.availableDates || []);
  //     } catch (err) {
  //       console.error('Error fetching available transaction dates', err);
  //     }
  //   };

  //   fetchAvailableDates();
  // }, []);


  // Single entry working as per the 25/6/25

  // const generatePayoutFile = (bankName, reportData) => {
  //   if (!reportData || !reportData.summary || !reportData.summary.detailedEntries) {
  //     alert("No report data found.");
  //     return;
  //   }

  //   const data = reportData.summary.detailedEntries;
  //   let formattedData;
  //   let headers;

  //   if (bankName === "Ujjivan Bank") {
  //     formattedData = data.map((entry) => {
  //       // console.log('entry==============', entry);
  //       // payableToPartner
  //       const bankDetails = entry.serviceType === "taxi" ? entry.riderBankDetails : entry.theaterBankDetails || {};

  //       return {
  //         "Identifier": "NFT",
  //         "Unique reference number": entry.transactionId || "N/A",
  //         //   "Amount": entry.customerAmount || 0,
  //         "Amount": entry.payableToPartner || 0,
  //         "Debit Account number": "XXXXXX1234",
  //         "Beneficiary Name": bankDetails.accountHolderName || bankDetails.beneficiaryName || "N/A",
  //         "Beneficiary Address": bankDetails.branchName || "",
  //         "Beneficiary Account number": bankDetails.accountNumber || "N/A",
  //         "Beneficiary Bank IFSC code": bankDetails.ifscCode || bankDetails.IFSC || "N/A",
  //         "Beneficiary Bank Name": bankDetails.bankName || "N/A",
  //         "Remarks": "",
  //         "LEI": ""
  //       };
  //     });
  //     headers = Object.keys(formattedData[0]);
  //   }

  //   const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });
  //   const colWidths = headers.map(header => ({ wch: Math.max(header.length + 5, 15) }));
  //   ws["!cols"] = colWidths;

  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, bankName.replace(" ", "_"));
  //   const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
  //   XLSX.writeFile(wb, `${bankName.replace(" ", "_")}_Payout_${timestamp}.xlsx`);
  // };




  // Combined values for the same account



  // 🔹 Helper to group entries by account
  const groupEntriesByAccount = (entries) => {
    const grouped = {};

    entries.forEach(entry => {
      const bankDetails = entry.serviceType === "taxi"
        ? entry.riderBankDetails
        : entry.theaterBankDetails || {};

      const key = `${bankDetails.accountNumber}_${bankDetails.ifscCode || bankDetails.IFSC}`;

      if (!grouped[key]) {
        grouped[key] = {
          bankDetails,
          totalAmount: 0
        };
      }

      grouped[key].totalAmount += entry.payableToPartner || 0;
    });

    return Object.values(grouped).map(({ bankDetails, totalAmount }) => ({
      "Identifier": "NFT",
      "Unique reference number": "Grouped",
      "Amount": totalAmount.toFixed(2),
      "Debit Account number": "XXXXXX1234",
      "Beneficiary Name": bankDetails.accountHolderName || bankDetails.beneficiaryName || "N/A",
      "Beneficiary Address": bankDetails.branchName || "",
      "Beneficiary Account number": bankDetails.accountNumber || "N/A",
      "Beneficiary Bank IFSC code": bankDetails.ifscCode || bankDetails.IFSC || "N/A",
      "Beneficiary Bank Name": bankDetails.bankName || "N/A",
      "Remarks": "",
      "LEI": ""
    }));
  };






  const generatePayoutFileForReport = (bankName, reportData) => {
    if (!reportData || !reportData.summary || !reportData.summary.detailedEntries) {
      alert("No report data found.");
      return;
    }

    const data = reportData.summary.detailedEntries;
    let formattedData;
    let headers;

    if (bankName === "Ujjivan Bank") {
      formattedData = groupEntriesByAccount(data);   // 🔥 use helper function
      headers = Object.keys(formattedData[0]);
    }

    const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });
    const colWidths = headers.map(header => ({ wch: Math.max(header.length + 5, 15) }));
    ws["!cols"] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, bankName.replace(" ", "_"));
    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
    XLSX.writeFile(wb, `${bankName.replace(" ", "_")}_Payout_${timestamp}.xlsx`);
  };



  // 🔹 New function: filter by serviceType (taxi/theater)
  const generatePayoutFileByService = (bankName, reportDataTT, serviceType) => {

    
    if (!reportDataTT || !reportDataTT.summary?.detailedEntries) {
      alert("No report data found.");
      return;
    }

    const filtered = reportDataTT.summary.detailedEntries.filter(
      e => e.serviceType === serviceType
    );

    if (filtered.length === 0) {
      alert(`No ${serviceType} entries found in this report.`);
      return;
    }

    const grouped = {};
    filtered.forEach(entry => {
      const bankDetails = entry.serviceType === "taxi"
        ? entry.riderBankDetails
        : entry.theaterBankDetails || {};

      const key = `${bankDetails.accountNumber}_${bankDetails.ifscCode || bankDetails.IFSC}`;

      if (!grouped[key]) {
        grouped[key] = { bankDetails, totalAmount: 0 };
      }
      grouped[key].totalAmount += entry.payableToPartner || 0;
    });

    const formattedData = Object.values(grouped).map(({ bankDetails, totalAmount }) => ({
      "Identifier": "NFT",
      "Unique reference number": "Grouped",
      "Amount": totalAmount.toFixed(2),
      "Debit Account number": "XXXXXX1234",
      "Beneficiary Name": bankDetails.accountHolderName || bankDetails.beneficiaryName || "N/A",
      "Beneficiary Address": bankDetails.branchName || "",
      "Beneficiary Account number": bankDetails.accountNumber || "N/A",
      "Beneficiary Bank IFSC code": bankDetails.ifscCode || bankDetails.IFSC || "N/A",
      "Beneficiary Bank Name": bankDetails.bankName || "N/A",
      "Remarks": "",
      "LEI": ""
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData, { header: Object.keys(formattedData[0]) });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, serviceType);

    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
    XLSX.writeFile(wb, `${serviceType}_${bankName}_Payout_${timestamp}.xlsx`);
  };












  const generatePayoutFile = (bankName, reportData) => {

    console.log('report data', reportData);

    if (!reportData || !reportData.summary || !reportData.summary.detailedEntries) {
      alert("No report data found.");
      return;
    }

    const data = reportData.summary.detailedEntries;
    let formattedData;
    let headers;

    // 🔁 GROUP BY ACCOUNT for Ujjivan Bank
    const groupByAccount = (entries) => {
      const grouped = {};

      entries.forEach(entry => {
        const bankDetails = entry.serviceType === "taxi" ? entry.riderBankDetails : entry.theaterBankDetails || {};
        const key = `${bankDetails.accountNumber}_${bankDetails.ifscCode || bankDetails.IFSC}`;

        if (!grouped[key]) {
          grouped[key] = {
            bankDetails,
            totalAmount: 0
          };
        }

        grouped[key].totalAmount += entry.payableToPartner || 0;
      });

      return Object.values(grouped).map(({ bankDetails, totalAmount }) => ({
        "Identifier": "NFT",
        "Unique reference number": "Grouped", // optional or set to one of the transactionIds
        "Amount": reportData.finalPayableAmount?.toFixed(2) || "N/A",
        "Debit Account number": "XXXXXX1234",
        "Beneficiary Name": bankDetails.accountHolderName || bankDetails.beneficiaryName || "N/A",
        "Beneficiary Address": bankDetails.branchName || "",
        "Beneficiary Account number": bankDetails.accountNumber || "N/A",
        "Beneficiary Bank IFSC code": bankDetails.ifscCode || bankDetails.IFSC || "N/A",
        "Beneficiary Bank Name": bankDetails.bankName || "N/A",
        "Remarks": "",
        "LEI": ""
      }));
    };

    if (bankName === "Ujjivan Bank") {
      const groupedData = groupByAccount(data);
      formattedData = groupedData;
      headers = Object.keys(formattedData[0]);
    }

    const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });
    const colWidths = headers.map(header => ({ wch: Math.max(header.length + 5, 15) }));
    ws["!cols"] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, bankName.replace(" ", "_"));
    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
    XLSX.writeFile(wb, `${bankName.replace(" ", "_")}_Payout_${timestamp}.xlsx`);
  };




  function formatDateUTC(dateStr) {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: "UTC", // prevents shifting to IST
    });
  }




  return (
    <div className="container mx-auto max-w-5xl p-4">
      <h1 className="text-2xl font-bold mb-6">Settlement Report</h1>
      {/* {message && (
  <div className="inline-block max-w-fit px-3 py-1 mb-4 text-xs text-white bg-green-600 rounded">
    {message}
  </div>
)} */}

{message && (
  <div className="inline-block max-w-fit px-3 py-1 mb-4 text-xs text-gray-700 bg-gray-100 rounded border border-gray-300">
    {message}
  </div>
)}

<Snackbar
      open={snackbar.open}
      autoHideDuration={4000}
      onClose={hideSnackbar}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert 
        onClose={hideSnackbar} 
        severity={snackbar.severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>






      {/* <select className="border p-2 rounded mb-4 w-64">
        <option disabled selected>Check Available Dates</option>
        {availableDates.map((date) => (
          <option key={date} value={date}>{date}</option>
        ))}
      </select> */}

      {/* <select className="border p-2 rounded mb-4 w-64">
        <option disabled selected>Check Available Dates</option>
        {availableDates.map((item) => (
          <option key={item.date} value={item.date}>
            {item.date} {item.isCommitted ? `(Committed)` : ''}
          </option>
        ))}
      </select> */}

     


      {/* <select
        className="border ml-2 p-2 rounded mb-4 w-64"
        value={selectedReport || ""}
        onChange={(e) => setSelectedReport(e.target.value)}
      >
        <option value="">-- Select a committed report --</option>
        {committedReports.map(r => (
          <option key={r._id} value={r._id}>
            {new Date(r.periodStart).toLocaleDateString("en-IN")} →
            {new Date(r.periodEnd).toLocaleDateString("en-IN")} ({r.reportType})
          </option>
        ))}
      </select> */}


      {(isReportViewer || currentStep === 3) && (
      <div className="flex items-center gap-2 mb-4">
        {!isReportViewer && (
          <select className="border p-2 rounded w-64">
            <option disabled selected>Check Available Dates</option>
            {availableDates.map((item) => (
              <option key={item.date} value={item.formattedDate}>
                {item.formattedDate} {item.isCommitted ? `(Committed)` : ''}
              </option>
            ))}
          </select>
        )}

        <select
          className="border p-2 rounded w-64"
          value={selectedReport || ""}
          onChange={(e) => setSelectedReport(e.target.value)}
        >
          <option value="">-- Select a committed report --</option>
          {committedReports.map(r => (
            <option key={r._id} value={r._id}>
              {formatDateUTC(r.periodStart)} → {formatDateUTC(r.periodEnd)}
            </option>
          ))}
        </select>

        {!isReportViewer && (
          <button
            className="bg-green-500 text-white text-sm px-3 py-2 rounded"
            onClick={() => {
              if (!selectedReport) return alert("Please select a report first.");
              generatePayoutFileByService("Ujjivan Bank", reportDataTT, "taxi");
            }}
          >
            Taxi Report
          </button>
        )}

        {isReportViewer ? (
          <>
            <button
              className="bg-blue-600 text-white text-sm px-3 py-2 rounded"
              onClick={() => {
                if (!selectedReport) return alert('Please select a report first.');
                generateCommittedTheaterPDF();
              }}
            >
              Download PDF
            </button>
            <button
              className="bg-red-600 text-white text-sm px-3 py-2 rounded"
              onClick={() => {
                if (!selectedReport) return alert('Please select a report first.');
                generateTicketsReceiptPDF();
              }}
            >
              Payment Receipt
            </button>
          </>
        ) : (
          <>
            <button
              className="bg-red-500 text-white text-sm px-3 py-2 rounded"
              onClick={() => {
                if (!selectedReport) return alert("Please select a report first.");
                generatePayoutFileByService("Ujjivan Bank", reportDataTT, "theater");
              }}
            >
              Tickets Report
            </button>
            <button
              className="bg-blue-600 text-white text-sm px-3 py-2 rounded"
              onClick={() => {
                if (!selectedReport) return alert('Please select a report first.');
                generateCommittedTheaterPDF();
              }}
            >
              Download PDF
            </button>
            <button
              className="bg-red-600 text-white text-sm px-3 py-2 rounded"
              onClick={() => {
                if (!selectedReport) return alert('Please select a report first.');
                generateTicketsReceiptPDF();
              }}
            >
              Payment Receipt
            </button>
          </>
        )}
      </div>
      )
      // {
        /* {reportData && (
        <div className="mt-4 flex gap-4">
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded"
            onClick={() => generatePayoutFileByService("Ujjivan Bank", reportData, "taxi")}
          >
            Download Taxi Payout
          </button>

          <button
            className="bg-green-600 text-white px-4 py-2 rounded"
            onClick={() => generatePayoutFileByService("Ujjivan Bank", reportData, "theater")}
          >
            Download Theater Payout
          </button>
        </div>
      )} */}




      {!isReportViewer && currentStep === 3 && (
        // <Step3
        //   setReportData={setReportData}
        //   selectedEntries={selectedEntries}
        //   setSelectedEntries={setSelectedEntries}
        //   success="Report ready!"
        //   nextStep={() => setCurrentStep(4)}
        // />





        // <Step3
        //   success="Report generated"
        //   nextStep={() => setCurrentStep(4)}
        //   selectedEntries={selectedEntries}
        //   setSelectedEntries={setSelectedEntries}
        //   reportData={reportData}
        //   setReportData={setReportData}
        //   fromDate={fromDate}
        //   setFromDate={setFromDate}
        //   toDate={toDate}
        //   setToDate={setToDate}
        //   reportType={reportType}
        //   setReportType={setReportType}
        // />


        <Step3
          reportData={reportData}
          nextStep={() => setCurrentStep(4)}
          setReportData={setReportData}
          selectedEntries={selectedEntries}
          setSelectedEntries={setSelectedEntries}
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
          reportType={reportType}
          setReportType={setReportType}
          reportGenerated={reportGenerated}
          setReportGenerated={setReportGenerated}
        />

      )}

      {/* Email send section: show only when a committed report is selected */}
      {selectedReport && (
        <div className="mt-4 p-4 border rounded bg-white">
          <h3 className="font-medium mb-3">Send Selected Committed Report via Email</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
            <div>
              <label className="block text-sm text-gray-700 mb-1">Recipient Emails</label>
              <input
                type="text"
                placeholder="e.g. user1@example.com, user2@example.com"
                value={emailInput}
                onChange={e => setEmailInput(e.target.value)}
                className="w-full border rounded p-2"
              />
              <p className="text-xs text-gray-500 mt-1">Separate multiple emails with comma or space</p>
            </div>
            <div className="flex items-end gap-4">
              <label className="inline-flex items-center">
                <input type="checkbox" className="mr-2" checked={includeReceipt} onChange={e=>setIncludeReceipt(e.target.checked)} />
                Attach: Payment Receipt (PDF)
              </label>
              <label className="inline-flex items-center">
                <input type="checkbox" className="mr-2" checked={includeSettlement} onChange={e=>setIncludeSettlement(e.target.checked)} />
                Attach: Settlement Report (PDF)
              </label>
            </div>
            <div>
              <label className="block text-sm text-gray-700 mb-1">Subject (optional)</label>
              <input
                type="text"
                value={emailSubject}
                onChange={e=>setEmailSubject(e.target.value)}
                className="w-full border rounded p-2"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700 mb-1">Message (optional)</label>
              <textarea
                rows={3}
                value={emailBody}
                onChange={e=>setEmailBody(e.target.value)}
                className="w-full border rounded p-2"
              />
            </div>
          </div>
          <div className="flex justify-end">
            <button
              disabled={isSending || (!includeReceipt && !includeSettlement)}
              onClick={handleSendEmail}
              className={`px-4 py-2 rounded text-white ${isSending ? 'bg-gray-400' : 'bg-indigo-600 hover:bg-indigo-700'}`}
            >
              {isSending ? 'Sending…' : 'Send Email'}
            </button>
          </div>
        </div>
      )}












      {!isReportViewer && currentStep === 4 && reportData && (
        <Step4
          reportData={reportData}
          selectedEntries={selectedEntries}
          generatePayoutFile={generatePayoutFile}
          onBack={() => setCurrentStep(3)}
        />
      )}
    </div>
  );
};

export default SettlementReportPage;
